var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow 5",
    d: "M0.263956 3.75068C0.0572224 3.95741 0.0572224 4.29259 0.263956 4.49932L3.63288 7.86825C3.83961 8.07498 4.17479 8.07498 4.38153 7.86825C4.58826 7.66151 4.58826 7.32633 4.38153 7.1196L1.38693 4.125L4.38153 1.1304C4.58826 0.923669 4.58826 0.588487 4.38153 0.381753C4.17479 0.17502 3.83961 0.17502 3.63288 0.381753L0.263956 3.75068ZM12.7383 3.59562L0.638281 3.59562V4.65438L12.7383 4.65438V3.59562Z",
    fill: "#9D9FA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.958da17eaa1b393b74e7f9e04266f70b.svg";
export { ForwardRef as ReactComponent };